import { ClassifierData } from 'types/classifiers';
import { ExpenseTypeGroup } from 'types/expenses';
import { getClassifierText } from 'utils/getTranslations';

export { sortByNumericAccessor } from 'components/tables/list-table/sortUtil';

/**
 * Tier 1 sort is "A-Z by translated expense-type name", which the BE can't do without the
 * current locale's classifier translations — so the BE returns groups unordered and we sort
 * here. Locale-aware via Intl.Collator (sensitivity: 'base' to fold case + diacritics).
 *
 * Pure helper extracted from ExpensesGroupedTable so it can be unit-tested without mounting
 * the full component.
 */
const expenseTypeCollator = new Intl.Collator(undefined, { sensitivity: 'base' });

export const sortTier1ByTranslatedType = (
    groups: ExpenseTypeGroup[],
    expenseTypeClassifier: ClassifierData | undefined,
    desc = false
): ExpenseTypeGroup[] => {
    const direction = desc ? -1 : 1;
    return groups.toSorted(
        (a, b) =>
            direction *
            expenseTypeCollator.compare(
                getClassifierText(expenseTypeClassifier, a.expenseTypeCode) ?? a.expenseTypeCode,
                getClassifierText(expenseTypeClassifier, b.expenseTypeCode) ?? b.expenseTypeCode
            )
    );
};
